var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, _vm.hostClass]},[_c('share-activity-button'),_vm._v(" "),(!_vm.isMeetingEnded)?_c('ChangeTranscriptionLanguageButton'):_vm._e(),_vm._v(" "),_c('favourite'),_vm._v(" "),_c('add-to-playlist-button')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed0238b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/activity-summary/components/secondary-actions/secondary-actions.vue
// module id = JQti
// module chunks = 1